import styled from 'styled-components'

import { Glyphicon } from 'components/BootstrapShim'
import ModeSelector from 'components/ModeSelector'
import {
  btcColor,
  usdMillionsColor,
  usdThousandsColor,
} from 'components/Quantity'
import { useShouldColorCodeQuantityConversions } from 'hooks/useShouldColorCodeQuantityConversions'
import { assertNever } from 'types/assertNever'

import { useQuantityFormatting } from './provider'
import { FormatterOptions } from './types'

export const CurrencySelector: React.FC = () => {
  const { currencyOptions, selectedCurrency, setSelectedCurrency } =
    useQuantityFormatting()
  const shouldColorCodeQuantityConversions =
    useShouldColorCodeQuantityConversions()
  return (
    <ModeSelector
      buttonProps={{ size: 'sm' }}
      modes={currencyOptions}
      selectedMode={selectedCurrency}
      setMode={setSelectedCurrency}
      formatMode={currency => {
        switch (currency) {
          case 'Native':
            return <Glyphicon glyph="ban" />
          case 'USD':
            return <Glyphicon glyph="dollar" />
          case 'BTC':
            return (
              <span
                style={
                  shouldColorCodeQuantityConversions ? { color: btcColor } : {}
                }
              >
                <Glyphicon glyph="bitcoin" />
              </span>
            )
          default:
            return currency
        }
      }}
    />
  )
}

export const FormatterSelector: React.FC = () => {
  const { selectedFormatter, setSelectedFormatter } = useQuantityFormatting()
  const shouldColorCodeQuantityConversions =
    useShouldColorCodeQuantityConversions()
  return (
    <ModeSelector
      buttonProps={{ size: 'sm' }}
      modes={[...FormatterOptions]}
      selectedMode={selectedFormatter}
      setMode={setSelectedFormatter}
      formatMode={format => {
        switch (format) {
          case 'Full':
            return <Glyphicon glyph="expand" />
          case 'Compact':
            return <Glyphicon glyph="compress" />
          case 'Millions':
            return (
              <span
                style={
                  shouldColorCodeQuantityConversions
                    ? { color: usdMillionsColor }
                    : {}
                }
              >
                <Glyphicon glyph="dollar" />M
              </span>
            )
          case 'Thousands':
            return (
              <span
                style={
                  shouldColorCodeQuantityConversions
                    ? { color: usdThousandsColor }
                    : {}
                }
              >
                <Glyphicon glyph="dollar" />K
              </span>
            )
          default:
            return assertNever(format)
        }
      }}
    />
  )
}

const Wrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  align-items: center;
  gap: 0.5em;
  justify-content: flex-end;
`

const SelectorWrapper = styled.div`
  position: relative;
  border: 1px solid #999;
  padding: 5px;
`

const Label = styled.label`
  position: absolute;
  top: -10px;
  max-width: 100%;
  z-index: 1;
  color: #999;
  border-radius: 1em;
  font-size: 0.8rem;
  padding: 0 0.25em;
  background: #f8f9fa;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const QuantityFormattingSelectors = () => {
  return (
    <Wrapper>
      <SelectorWrapper>
        <Label>Currency</Label>
        <CurrencySelector />
      </SelectorWrapper>
      <SelectorWrapper>
        <Label>Number format</Label>
        <FormatterSelector />
      </SelectorWrapper>
    </Wrapper>
  )
}
